import { defineMessages } from 'react-intl';

export default defineMessages({
    searchByAccount: {
        id: 'gateway.directives.gateway-dashboard.search.Search by account or policy ID number',
        defaultMessage: 'Search by account or policy ID number'
    },
    noSearchResultsFound: {
        id: 'gateway.directives.gateway-dashboard.search.No results found',
        defaultMessage: 'No results found'
    },
    recentlyVisitedAccounts: {
        id: 'gateway.views.dashboard.Recently Visited Accounts',
        defaultMessage: 'Recently Visited Accounts'
    },
    recentlyVisitedPolicies: {
        id: 'gateway.views.dashboard.Recently Visited Policies',
        defaultMessage: 'Recently Visited Policies'
    },
    noAccountsFound: {
        id: 'gateway.views.dashboard.No Accounts Found',
        defaultMessage: 'No Accounts Found'
    },
    noPoliciesFound: {
        id: 'gateway.views.dashboard.No Policies Found',
        defaultMessage: 'No Policies Found'
    },
    searchResults: {
        id: 'gateway.directives.gateway-dashboard.search.Search Results',
        defaultMessage: 'Search Results for "{query}"'
    }
});
